// Japanese

const lang = {
  gateMediaPreviewHeader: 'こちらもお好みに合うかもしれません',
  loadmore: 'もっと表示',
  nextMedia: '次のメディア',
  previousMedia: '前のメディア',
  closePost: '投稿を閉じる',
  nextPost: '次の投稿',
  previousPost: '前の投稿',
  outOfStock: '在庫切れ',
  numberOfReviews() {
    return '件のレビュー'
  },
  reportFormField: 'メッセージを入力してください',
  reportPost: '投稿を報告する',
  reportFormTitle: 'この画像を報告しますか？',
  reportFormDetails:
    '画像が不適切、違法、または誰かの権利を侵害していると思われる場合は、コンテンツを報告できます。画像/テキストを報告すると、コンテンツモデレーターに通知され、適切な処置がとられます',
  reportFormMessagePlaceholder: '報告の理由を明記してください',
  reportFormMessageLabel: 'メッセージ',
  reportFormEmailLabel: 'お客様のEメール',
  reportFormSubmitButtonText: '報告を送信する',
  reportFormCancelButtonText: 'キャンセル',
  reportFormSentTitle: 'ご報告ありがとうございます',
  reportFormSentCloseButtonText: '閉じる',
  cardAndTileAriaLabel:
    '以下は、さまざまなソーシャル メディア プラットフォームのアカウントからの投稿のリストです。',
  carouselAriaLabel:
    '以下は、様々なソーシャルメディアにおけるアカウントによる投稿を含むカルーセルです',
  singleAriaLabel: '以下はソーシャルメディアアカウントからの投稿です',
  poweredBy: '提供元：Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date && !userName ? `${date} に投稿された写真` : ''
    const createdByString = userName && !date ? `${userName} が投稿した写真` : ''
    const fullString = date && userName ? `${date} に ${userName} が投稿した写真` : ''
    const photo = !date && !userName ? '写真' : ''
    return `${fullString}${photo}${createdByString}${publishedString}`
  },
  uploadYourMedia: 'メディアをアップロードする',
  openTheGate: 'ダイアログを開く',
}

export default lang
